import React from "react";
import NumberFormat from "react-number-format";
import { LuPlus, LuTrash2 } from "react-icons/lu";
import "./CostItemsTable.css";

export const UNIT_OPTIONS = [
  { value: "metros", label: "Metros" },
  { value: "unidade", label: "Unidade" },
  { value: "kilos", label: "Kilos" },
];

function optionValue(option) {
  return typeof option === "string" ? option : option.value;
}

function optionLabel(option) {
  return typeof option === "string" ? option : option.label;
}

const CostItemsTable = ({
  title,
  items,
  columns,
  totalLabel,
  totalValue,
  onAdd,
  onUpdate,
  onDelete,
}) => {
  return (
    <div className="cit-section">
      <div className="cit-header">
        <h3 className="cit-title">{title}</h3>
        <button type="button" className="cp-btn cp-btn--secondary cit-add-btn" onClick={onAdd}>
          <LuPlus size={14} /> Adicionar item
        </button>
      </div>

      <div className="cit-table-scroll">
        <table className="cit-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={index}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.type === "select" ? (
                      <select
                        className="cp-select cit-input"
                        value={item[col.key] || ""}
                        onChange={(e) => onUpdate(index, col.key, e.target.value)}
                      >
                        <option value="">Selecione</option>
                        {col.options.map((option) => (
                          <option key={optionValue(option)} value={optionValue(option)}>
                            {optionLabel(option)}
                          </option>
                        ))}
                      </select>
                    ) : col.type === "number" ? (
                      <input
                        type="number"
                        className="cp-input cit-input"
                        value={item[col.key] ?? ""}
                        onChange={(e) => onUpdate(index, col.key, e.target.value)}
                      />
                    ) : col.type === "currency" ? (
                      <NumberFormat
                        className="cp-input cit-input"
                        value={item[col.key]}
                        displayType="input"
                        thousandSeparator="."
                        prefix="R$"
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalSeparator=","
                        onValueChange={(values) => onUpdate(index, col.key, values.floatValue)}
                      />
                    ) : (
                      <input
                        type="text"
                        className="cp-input cit-input"
                        value={item[col.key] || ""}
                        onChange={(e) => onUpdate(index, col.key, e.target.value)}
                      />
                    )}
                  </td>
                ))}
                <td className="cit-total-cell">
                  <NumberFormat
                    value={item.totalAmount}
                    displayType="text"
                    thousandSeparator="."
                    prefix="R$"
                    decimalScale={2}
                    fixedDecimalScale={true}
                    decimalSeparator=","
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="cit-delete-btn"
                    title="Remover item"
                    onClick={() => onDelete(index)}
                  >
                    <LuTrash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="cit-total-row">
        <span>{totalLabel}</span>
        <strong>
          <NumberFormat
            value={totalValue}
            displayType="text"
            thousandSeparator="."
            prefix="R$"
            decimalScale={2}
            fixedDecimalScale={true}
            decimalSeparator=","
          />
        </strong>
      </div>
    </div>
  );
};

export default CostItemsTable;
